import Axios from 'axios'
import { capitalize } from '@/utils/common'

import { setupCache } from 'axios-cache-interceptor'

const axios = setupCache(Axios)

const toVueComponentName = (__component) => capitalize(__component.split('.')[1], '-')

const getAllPages = () =>
  axios
    .get('/strapi/api/pages?locale=all&populate=deep')

const getAllHeaders = () =>
  axios
    .get(`/strapi/api/headers?locale=all&populate=deep`)

const getAllFooters = () =>
	axios
		.get(`/strapi/api/footers?locale=all&populate=deep`)

const getHeaderComponent = (locale) =>
  axios
    .get(`/strapi/api/headers?locale=${locale}&populate=deep`)
    .then(({ data }) => data.data[0]?.attributes)

const getFooterComponent = (locale) =>
  axios
    .get(`/strapi/api/footers?locale=${locale}&populate=deep`)
    .then(({ data }) => data.data[0]?.attributes)

const getPageComponents = (page, locale) =>
  axios
    .get(`/strapi/api/pages?locale=${locale}&filters[label][$eq]=${page}&populate=deep`)
    .then(({ data }) =>
      data.data[0]?.attributes.components.map(({ __component, ...rest }) => ({
        __component: toVueComponentName(__component),
        ...rest
      }))
    )

const getPagesInfo = (locale) =>
  axios.get(`/strapi/api/pages?locale=${locale}`).then(({ data: { data } }) =>
    data
      .sort((a, b) => a.attributes.position - b.attributes.position)
      .map((d) => ({
        label: d.attributes.label,
        locale: d.attributes.locale,
        route: d.attributes.route,
        showNavbar: d.attributes.position > 0
      }))
  )

const getFormValidation = (formName, locale) =>
  axios
    .get(
      `/strapi/api/form-validations?filters[FormName][$eqi]=${formName}&populate=deep&locale=${locale}`
    )
    .then(({ data }) => {
      const fieldValidations = data.data[0].attributes.FieldValidations.data
      const validationRules = fieldValidations
        .map((_) => _.attributes)
        .map((_) => ({ key: _.FieldName, value: _.ValidationRules }))
        .reduce(
          (acc, curr) => ({
            ...acc,
            [curr.key]: curr.value.reduce(
              (acc, curr) => ({ ...acc, [curr.RuleName]: curr.ErrorMessage }),
              {}
            )
          }),
          {}
        )
      return validationRules
    })

const getSignatureForm = (locale, isCRC) => {
  const formPromise = axios
    .get(`/strapi/api/signature-forms?filters[isCRC][$eq]=${isCRC}&locale=${locale}&populate=deep`)
    .then(({ data }) => data.data[0]?.attributes)
  const validationsPromise = getFormValidation('SignatureForm', locale)

  return Promise.all([formPromise, validationsPromise])
}

const getCategoryQuestionnaireForm = (locale) => {
  const formPromise = axios
    .get(`/strapi/api/questionnaire-forms?locale=${locale}&populate=deep`)
    .then(({ data }) => data.data[0]?.attributes)
  const validationsPromise = getFormValidation('QuestionnaireForm', locale)

  return Promise.all([formPromise, validationsPromise])
}

const getConsentProcessDocumentation = (locale) => {
  const formPromise = axios
    .get(`/strapi/api/consent-process-documentations?locale=${locale}&populate=deep`)
    .then(({ data }) => data.data[0]?.attributes)
  const validationsPromise = getFormValidation('ConsentProcessDocumentation', locale)

  return Promise.all([formPromise, validationsPromise])
}

const strapi = {
  getAllPages,
  getAllHeaders,
	getAllFooters,
  getHeaderComponent,
  getFooterComponent,
  getPageComponents,
  getPagesInfo,
  getFormValidation,
  getSignatureForm,
  getCategoryQuestionnaireForm,
	getConsentProcessDocumentation,
  toVueComponentName
}

export { strapi }
